import { HiOutlineMoon, HiOutlineSun } from "react-icons/hi2";
import styled, { css } from "styled-components";
import WaveIcon from "./icons/WaveIcon";
import { useDarkMode } from "../context/DarkModeContext";

const StyledButtonGroup = styled.div``;

const ThemeButton = styled.button`
  background: none;
  border: 1px solid var(--color-border);
  padding: 0.2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  color: var(--icon-color-secondary);

  &:nth-child(1) {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  &:nth-child(2) {
    border-left: none;
    border-right: none;
  }

  &:nth-child(3) {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  & svg {
    width: 1.5rem;
    height: 1.5rem;
    color: var(--icon-color-secondary);
    stroke: var(--icon-color-secondary);
  }

  &:hover {
    background-color: var(--color-active);

    & svg {
      stroke: var(--color-active-text);
    }
  }

  ${(props) =>
    props.activeTheme &&
    css`
      background-color: var(--color-active);

      & svg {
        stroke: var(--color-active-text);
      }
    `}
`;

function ToggleTheme() {
  const { theme, toggleTheme } = useDarkMode();

  return (
    <StyledButtonGroup>
      <ThemeButton
        activeTheme={theme === "light"}
        onClick={() => toggleTheme("light")}
      >
        <HiOutlineSun />
      </ThemeButton>
      <ThemeButton
        activeTheme={theme === "classic"}
        onClick={() => toggleTheme("classic")}
      >
        <WaveIcon />
      </ThemeButton>
      <ThemeButton
        activeTheme={theme === "dark"}
        onClick={() => toggleTheme("dark")}
      >
        <HiOutlineMoon />
      </ThemeButton>
    </StyledButtonGroup>
  );
}

export default ToggleTheme;
